module.exports = __webpack_public_path__ + "img/Logo-novo.a13edff0.svg";